export default function(url) {
  let hash = url.indexOf('#');

  if (hash === -1) {
    return url;
  }

  return url.substr(0, hash);
}
